<div class="dialog-backdrop" (click)="dismiss('backdrop')">
  <div class="dialog-box animate-popup" (click)="$event.stopPropagation()">
    <div class="dialog-icon" [style.background]="iconColor">
      <ion-icon [name]="iconName"></ion-icon>
    </div>

    <h2>{{ title }}</h2>
    <p>{{ message }}</p>

    <div class="button-row" *ngIf="showYesNo; else okOnly">
      <ion-button expand="block" color="medium" (click)="dismiss('no')" class="btn">
        {{ noText }}
      </ion-button>
      <ion-button expand="block" [color]="buttonColor" (click)="dismiss('yes')" class="btn">
        {{ yesText }}
      </ion-button>
    </div>

    <ng-template #okOnly>
      <ion-button expand="block" [color]="buttonColor" (click)="dismiss('ok')" class="ok-btn">
        {{ buttonText }}
      </ion-button>
    </ng-template>
  </div>
</div>
